import themeImage from "../assets/lights.jpg";
import colorPalette from "../mixins/colorPaletteExtraction.js";

let gottenPalette = [];

async function generatePalette() {
    if(gottenPalette.length == 0) {
        let img = document.createElement("img");
        img.src = themeImage;

        gottenPalette = await colorPalette.extract(img).then(res => res);
        return gottenPalette;
    }
    return gottenPalette;
}

export default {
    generatePalette
}